import { render, staticRenderFns } from "./OpenAssetDetails.vue?vue&type=template&id=615fabf4&"
import script from "./OpenAssetDetails.vue?vue&type=script&lang=ts&"
export * from "./OpenAssetDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615fabf4')) {
      api.createRecord('615fabf4', component.options)
    } else {
      api.reload('615fabf4', component.options)
    }
    module.hot.accept("./OpenAssetDetails.vue?vue&type=template&id=615fabf4&", function () {
      api.rerender('615fabf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/OpenAssetDetails.vue"
export default component.exports